import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import Template from "../../../Shared-ui/Types/Template";
import { isWebsiteAddress, normalizeUrl } from "../../../Shared-ui/utils/Common/Common";
import { AgentWebsite, Website } from "../../../Shared-ui/Types/common";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { CREATE_WEBSITE, UPDATE_WEBSITE, WEBSITE_LINKS } from "../../../Services/Endpoint";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";


interface MyComponentProps {
  knowledgeBase: OldAgent | Template | any;
  setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | Template | any>>;
  getknowledgeBase: () => void;
  updateknowledgeBase: () => void;
}

const SourceWebsite: React.FC<MyComponentProps> = (props) => {
  const urlErrInitial = { value: false, error: "" }
  const linksDataInitial = { url: "", urls: [] }
  const [isExpaned, setIsExpanded] = useState<boolean>(false); // Track expanded panel
  const [isEditing, setIsEditing] = useState<boolean>(false); // Track expanded panel
  const [url, setUrl] = useState({ website: "" })
  const [urlErr, setUrlErr] = useState(urlErrInitial)
  const [linksData, setLinksData] = useState<{ url?: string; urls?: Website[] }>(linksDataInitial)
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false, });
  const [websites, setWebsites] = useState([])
  const dispatch = useDispatch()


  useEffect(() => {
    setWebsites(props.knowledgeBase?.website || [])
  }, [props.knowledgeBase])

  const getWebsiteLinks = async () => {
    if (!validateWebsite()) return;
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.post(WEBSITE_LINKS, url).then(res => res.data.detail)
      setLinksData(data.response)
      setIsExpanded(true)
    } catch (error: any) {
      dispatch(ShowError(error?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())
    }
  }

  const updateWebsite = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.put(`${UPDATE_WEBSITE}/${props.knowledgeBase.id}/websites`, linksData).then(res => res.data.detail)
      dispatch(ShowSuccess(data.response))
      setLinksData(linksDataInitial)
      setIsExpanded(false)
    } catch (error: any) {
      dispatch(ShowError(error?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())
    }
  }
  const deleteWebsite = async (row: string) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading())
      const data = await MetaInstance.delete(`${UPDATE_WEBSITE}/${props.knowledgeBase.id}/websites?website=${row}`).then(res => res.data.detail)
      dispatch(ShowSuccess(data.response))
    } catch (error: any) {
      dispatch(ShowError(error?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())
    }
  }

  const getWebsite = async (row: string) => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${UPDATE_WEBSITE}/${props.knowledgeBase.id}/websites?website=${row}`, linksData).then(res => res.data.detail)
      setLinksData(data.response)
      setIsExpanded(true)
    } catch (error: any) {
      dispatch(ShowError(error?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())
    }
  }

  const validateWebsite = (): boolean => {
    let duplicateUrl = []
    if (url.website && isWebsiteAddress(url.website)) {
      const existingUrls = props.knowledgeBase?.website || []
      duplicateUrl = existingUrls.filter((item: AgentWebsite, index: number) => normalizeUrl(item.url || "") === normalizeUrl(url.website)) || []
    }
    if (!url.website || !isWebsiteAddress(url.website)) {
      setUrlErr((preVal) => ({ ...preVal, error: "Please enter valid url", value: true }))
      return false
    } else if (duplicateUrl.length > 0) {
      setUrlErr((preVal) => ({ ...preVal, error: "url already exist", value: true }))
      return false
    } else {
      setUrlErr({ ...urlErrInitial })
      return true
    }
  }



  const deleteConfirm = (row: string) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: deleteWebsite,
      functionParam: row,
    });
  };
  const handleCancel = () => {
    setIsExpanded(false); // Reset expanded state
  };

  const handleChnage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setUrl((preVal) => ({ ...preVal, [name]: value.trim() }))
  }

  const handleSelelction = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = event.target.checked
    setLinksData((preVal) => {
      let urls = preVal.urls
      if (urls && urls.length >= index) {
        urls[index].selection = value
        preVal.urls = urls
      }
      return { ...preVal }
    })
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Train with websites
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              my: 3,
            }}
          >
            <FormControl fullWidth variant="outlined" required error={urlErr.value}>
              <InputLabel
                htmlFor="website"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Website URL
              </InputLabel>
              <TextField
                //size="small"
                id="website"
                name="website"
                value={url.website}
                placeholder="https://www.example.com"
                sx={{ background: "white" }}
                onChange={handleChnage}
                error={urlErr.value}
                helperText={urlErr.error}
              />
            </FormControl>
            <Button
              variant="contained"
              disableElevation
              size="large"
              sx={{
                textTransform: "capitalize",
                whiteSpace: "nowrap",
              }}
              onClick={getWebsiteLinks}
            >
              Fetch links
            </Button>
          </Box>

          {/* agent websites  */}
          {props.knowledgeBase.website?.map((site: AgentWebsite, index: number) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
              key={index}
            >
              <Box
                sx={{
                  border: `solid 1px ${variables.borderColor}`,
                  p: 1,
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  <CheckCircleIcon />
                  <Typography>{site.url}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  <Chip
                    icon={<CheckCircleOutlinedIcon />}
                    label={site.trainingStatus || ""}
                    variant="outlined"
                  />
                  <Box>
                    <IconButton
                      aria-label="view"
                      onClick={() => getWebsite(site.url || "")}
                    >
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => deleteConfirm("ad")}>
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>







      {isExpaned && (
        <Box
          sx={{
            "&::before": {
              content: '""',
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 7,
            },
          }}
        >
          <Box
            sx={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              pt: "10px",
              position: "fixed",
              right: "0",
              top: "0",
              height: "100vh",
              background: variables.whiteColor,
              padding: "20px 30px",
              zIndex: 8,
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    {linksData?.url || ""}
                  </Typography>
                  <IconButton aria-label="close" onClick={handleCancel}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    mt: 2,
                    pt: "5px",
                    height: "calc(100vh - 160px)",
                    overflow: "auto",
                  }}
                >
                  <FormGroup>
                    {linksData.urls?.map((url, index) => (
                      <Box sx={{ borderBottom: 1, borderColor: "divider", }}>
                        <FormControlLabel
                          control={<Checkbox checked={url.selection} value={url.selection} onChange={(e) => handleSelelction(e, index)} name={url.title} />}
                          label={url.title}
                        />
                      </Box>
                    ))}
                  </FormGroup>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: 0,
                }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={handleCancel} // Call handleCancel on click
                >
                  Cancel
                </Button>

                <Button
                  fullWidth
                  variant="contained"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={updateWebsite}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      <ConfirmPopup details={confirmPopupData} />

    </Box>
  );
};

export default SourceWebsite;
